import { Grid, Stack } from "@mui/material";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../../utils/Functions";

export default function MainFooterWrapper({ children }) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  function GridItem({ children }) {
    return (
      <Grid item xs={4}>
        <Stack alignItems={"center"} justifyContent={"center"} height={"100%"}>
          {children}
        </Stack>
      </Grid>
    );
  }
  return <Fragment>{children}</Fragment>;
}
